import { useState } from 'react';
import type { OpsSession } from './types';
import { ACCESS_TOKEN_KEY, SESSION_KEY } from './constants';
import { queryClient } from './query-client';
import { readSession, persistSession } from './operations-utils';
import { LoginScreen } from './login-screen';
import { OperationsShell } from './operations-shell';

export function OpsPortal() {
  const [session, setSession] = useState<OpsSession | null>(() =>
    readSession(),
  );

  const handleLogin = (nextSession: OpsSession) => {
    persistSession(nextSession);
    setSession(nextSession);
  };

  const handleLogout = () => {
    sessionStorage.removeItem(SESSION_KEY);
    sessionStorage.removeItem(ACCESS_TOKEN_KEY);
    setSession(null);
    queryClient.clear();
  };

  const handleSessionRefresh = (nextSession: OpsSession) => {
    persistSession(nextSession);
    setSession(nextSession);
  };

  if (!session) {
    return <LoginScreen onLogin={handleLogin} />;
  }

  return (
    <OperationsShell
      session={session}
      onLogout={handleLogout}
      onSessionRefresh={handleSessionRefresh}
    />
  );
}
